import type { TemplateFormLanguage } from '../types/templateForms';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';

export interface NotificationTranslations {
    formSubmitted: string;
    draftAlreadySubmitted: string;
    intakeAlreadySubmitted: string;
    emailNotRecognized: string;
    autoSaveDraftFailed: string;
    somethingWentWrong: string;
    somethingWentWrongTryAgain: string;
    copiedLink: string;
    couldNotCopyLink: string;
    formLockedBy: (email: string) => string;
}

const ENGLISH_TRANSLATIONS: NotificationTranslations = {
    formSubmitted: 'Form has been submitted.',
    draftAlreadySubmitted: 'This draft intake form has already been submitted!',
    intakeAlreadySubmitted: 'This intake form has already been submitted!',
    emailNotRecognized:
        "Oops! That email isn't recognized. Make sure you're using the one you shared with the lawyer.",
    autoSaveDraftFailed: 'We could not save your draft automatically. Please save before leaving.',
    somethingWentWrong: 'Something went wrong!',
    somethingWentWrongTryAgain: 'Something went wrong. Please try again.',
    copiedLink: 'Copied link',
    couldNotCopyLink: 'Could not copy link',
    formLockedBy: (email) =>
        `Looks like ${email} is already editing this form. You’ll be able to access it once they’re done.`,
};

const FRENCH_TRANSLATIONS: NotificationTranslations = {
    formSubmitted: 'Le formulaire a été soumis.',
    draftAlreadySubmitted: 'Ce brouillon de formulaire d’admission a déjà été soumis!',
    intakeAlreadySubmitted: 'Ce formulaire d’admission a déjà été soumis!',
    emailNotRecognized:
        'Oups! Ce courriel n’est pas reconnu. Assurez-vous d’utiliser celui que vous avez communiqué à votre avocat.',
    autoSaveDraftFailed:
        'Nous n’avons pas pu enregistrer votre brouillon automatiquement. Veuillez l’enregistrer avant de quitter.',
    somethingWentWrong: 'Une erreur s’est produite!',
    somethingWentWrongTryAgain: 'Une erreur s’est produite. Veuillez réessayer.',
    copiedLink: 'Lien copié',
    couldNotCopyLink: 'Impossible de copier le lien',
    formLockedBy: (email) =>
        `Il semble que ${email} modifie déjà ce formulaire. Vous pourrez y accéder une fois qu’ils auront terminé.`,
};

export const NOTIFICATION_TRANSLATIONS: Record<TemplateFormLanguage, NotificationTranslations> = {
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
};

export function getNotificationTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): NotificationTranslations {
    return NOTIFICATION_TRANSLATIONS[language] ?? NOTIFICATION_TRANSLATIONS.en;
}
